/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TasksV2SubTypesEnum = 'ACTIVATE' | 'DEACTIVATE' | 'UPGRADE' | 'CREATE' | 'CREATE-IMPLICIT' | 'DELETE' | 'UPDATE' | 'CREATE-OD' | 'CANCEL' | 'ADD' | 'ENTER' | 'EXIT' | 'REQUEST' | 'ORG' | 'UPDATE-PROPERTIES' | 'COPY-CREDENTIALS' | 'ROTATE-CREDENTIALS' | 'DELETE-CREDENTIALS' | 'UPDATE-ACCESS-LIST' | 'SCHEDULE' | 'IMPORT' | 'CREATE-CDVX' | 'CREATE-DATASTORE' | 'DELETE-DATASTORE' | 'AUTHORIZE' | 'RECONFIGURE-OAUTH-APP' | 'DELETE-OAUTH-APP' | 'LINK' | 'UNLINK' | 'RECONFIGURE-IRR' | 'STREAMLINE_IRR_CONFIG' | 'ASSIGN_GCVE' | 'UNASSIGN_GCVE' | 'ASSIGN_VMCA' | 'UNASSIGN_VMCA' | 'ASSIGN_EVS' | 'UNASSIGN_EVS' | 'INDIVIDUAL' | 'FLEET';

export const TasksV2SubTypesEnum = {

    ACTIVATE: 'ACTIVATE' as TasksV2SubTypesEnum,

    DEACTIVATE: 'DEACTIVATE' as TasksV2SubTypesEnum,

    UPGRADE: 'UPGRADE' as TasksV2SubTypesEnum,

    CREATE: 'CREATE' as TasksV2SubTypesEnum,

    CREATE_IMPLICIT: 'CREATE-IMPLICIT' as TasksV2SubTypesEnum,

    DELETE: 'DELETE' as TasksV2SubTypesEnum,

    UPDATE: 'UPDATE' as TasksV2SubTypesEnum,

    CREATE_OD: 'CREATE-OD' as TasksV2SubTypesEnum,

    CANCEL: 'CANCEL' as TasksV2SubTypesEnum,

    ADD: 'ADD' as TasksV2SubTypesEnum,

    ENTER: 'ENTER' as TasksV2SubTypesEnum,

    EXIT: 'EXIT' as TasksV2SubTypesEnum,

    REQUEST: 'REQUEST' as TasksV2SubTypesEnum,

    ORG: 'ORG' as TasksV2SubTypesEnum,

    UPDATE_PROPERTIES: 'UPDATE-PROPERTIES' as TasksV2SubTypesEnum,

    COPY_CREDENTIALS: 'COPY-CREDENTIALS' as TasksV2SubTypesEnum,

    ROTATE_CREDENTIALS: 'ROTATE-CREDENTIALS' as TasksV2SubTypesEnum,

    DELETE_CREDENTIALS: 'DELETE-CREDENTIALS' as TasksV2SubTypesEnum,

    UPDATE_ACCESS_LIST: 'UPDATE-ACCESS-LIST' as TasksV2SubTypesEnum,

    SCHEDULE: 'SCHEDULE' as TasksV2SubTypesEnum,

    IMPORT: 'IMPORT' as TasksV2SubTypesEnum,

    CREATE_CDVX: 'CREATE-CDVX' as TasksV2SubTypesEnum,

    CREATE_DATASTORE: 'CREATE-DATASTORE' as TasksV2SubTypesEnum,

    DELETE_DATASTORE: 'DELETE-DATASTORE' as TasksV2SubTypesEnum,

    AUTHORIZE: 'AUTHORIZE' as TasksV2SubTypesEnum,

    RECONFIGURE_OAUTH_APP: 'RECONFIGURE-OAUTH-APP' as TasksV2SubTypesEnum,

    DELETE_OAUTH_APP: 'DELETE-OAUTH-APP' as TasksV2SubTypesEnum,

    LINK: 'LINK' as TasksV2SubTypesEnum,

    UNLINK: 'UNLINK' as TasksV2SubTypesEnum,

    RECONFIGURE_IRR: 'RECONFIGURE-IRR' as TasksV2SubTypesEnum,

    STREAMLINE_IRR_CONFIG: 'STREAMLINE_IRR_CONFIG' as TasksV2SubTypesEnum,

    ASSIGN_GCVE: 'ASSIGN_GCVE' as TasksV2SubTypesEnum,

    UNASSIGN_GCVE: 'UNASSIGN_GCVE' as TasksV2SubTypesEnum,

    ASSIGN_VMCA: 'ASSIGN_VMCA' as TasksV2SubTypesEnum,

    UNASSIGN_VMCA: 'UNASSIGN_VMCA' as TasksV2SubTypesEnum,

    ASSIGN_EVS: 'ASSIGN_EVS' as TasksV2SubTypesEnum,

    UNASSIGN_EVS: 'UNASSIGN_EVS' as TasksV2SubTypesEnum,

    INDIVIDUAL: 'INDIVIDUAL' as TasksV2SubTypesEnum,

    FLEET: 'FLEET' as TasksV2SubTypesEnum
};

